( function () {
	'use strict';

	/* @ngInject */
	function timerDirective ( $interval, moment, _, $modal, $window, evidenceService ) {
		function link ( scope ) {
			scope.timerArr = [];
			// for updating time
			var changeTimeCall  = 'change:time:';
			// for quick access; changing buttons, disabling buttons etc.
			var changeQALabel   = 'change:label:timer:qa:';
			// call for changing buttons, disabling buttons in evidence bank
			var changeBankLabel = 'change:label:timer:bank:';
			// count for running timers. will be used during submit and save&close
			var activeTimers    = 0;
			var timeBefore      = new Date();
			var timeNow         = timeBefore;

			function stripMs ( newTime ) {
				// remove the last number in milliseconds
				return newTime.substring( 0, newTime.length - 1 );
			}

			// changing button label
			function changeLabelHandler ( evidenceData, start ) {
				setTimeout( function () {
					scope.$root.$broadcast( evidenceData.changeQALabel, start, evidenceData.description );
				}, 100 );
				scope.$root.$broadcast( evidenceData.changeBankLabel, start, evidenceData.description );
			}

			// this method is for time synchronization
			function startTimeHandler ( id ) {
				var evidence     = _.find( scope.timerArr, { 'id' : id } );
				var baseTime     = moment();
				var milliseconds = moment( evidence.description, 'HH:mm:ss.SSS' );

				if ( evidence && !evidence.interval ) {
					evidence.interval = setInterval( function () {
						var current = moment();

						milliseconds += current.diff( baseTime );

						baseTime = current;

						evidence.description = moment( milliseconds ).format( 'HH:mm:ss.SSS' );

						scope.$root.$broadcast( evidence.changeTimeCall, stripMs( evidence.description ) );
					}, 9 );

					changeLabelHandler( evidence, true );
					activeTimers++;
				}
			}

			function stopTimeHandler ( id ) {
				var evidence = _.find( scope.timerArr, { 'id' : id } );

				if ( evidence && evidence.interval ) {
					clearInterval( evidence.interval );

					evidence.interval = null;
					changeLabelHandler( evidence, false );
					activeTimers--;
				}
			}

			function clearTimeHandler ( id, fromAdd ) {
				var evidence         = _.find( scope.timerArr, { 'id' : id } );
				var originalEvidence = _.find( scope.model.masterEvidences, { 'id' : id } );

				evidence.description = '00:00:00.00';

				if ( !fromAdd ) {
					originalEvidence.description = '00:00:00.00';
					evidenceService.editDeleteEvidence( originalEvidence, 'edit', scope.model );
				}

				// change time for bank and quick access timer
				scope.$root.$broadcast( evidence.changeTimeCall, evidence.description );
			}

			function clearPopup ( id, fromAdd ) {
				if ( !fromAdd ) {
					var modalInstance = $modal.open( {
						'templateUrl'  : '/templates/components/delete-modal/delete-confirmation.html',
						'controller'   : 'DeleteConfirmationController',
						'controllerAs' : 'vm',
						'resolve'      : {
							'type' : function () {
								return 'clearTime';
							}
						}
					} );

					return modalInstance.result.then( function () {
						clearTimeHandler( id );
					} );
				}
				clearTimeHandler( id, fromAdd );
			}

			function checkActiveTimers ( submit ) {
				var notEmpty = false;

				if ( activeTimers > 0 ) {
					scope.$root.$broadcast( 'save:timer' );
					notEmpty = true;
				}

				var quickAccessData = {
					'activeTimers' : notEmpty,
					'submit'       : submit
				};

				scope.$parent.$parent.vm.updateObs( true, null, quickAccessData );
			}

			function pushToArray ( item ) {
				var timerEv = angular.copy( item );

				timerEv.changeTimeCall  = changeTimeCall + item.id;
				timerEv.changeQALabel   = changeQALabel + item.id;
				timerEv.changeBankLabel = changeBankLabel + item.id;
				timerEv.interval        = null;

				scope.timerArr.push( timerEv );
			}

			function addLostTime () {
				timeNow = new Date();

				var timeElapsed = moment.duration( timeNow.getTime() - timeBefore.getTime() );

				( scope.timerArr || [] ).map( function ( timer ) {
					if ( timer && timer.interval ) {
						var splittedTime = timer.description.split( ':' );
						var secMs        = splittedTime[ 2 ].split( '.' );

						timer.description = moment()
							.set( 'hour', splittedTime[ 0 ] )
							.set( 'minute', splittedTime[ 1 ] )
							.set( 'seconds', secMs[ 0 ] )
							.set( 'milliseconds', secMs[ 1 ] )
							.add( timeElapsed.seconds(), 'seconds' )
							.add( timeElapsed.minutes(), 'minute' )
							.add( timeElapsed.hours(), 'hour' )
							.format( 'HH:mm:ss.SSS' );
					}
				} );
			}

			function activate () {
				angular.forEach( scope.model.masterEvidences, function ( item ) {
					if ( item.type === 7 ) {
						pushToArray( item );
					}
				} );
			}

			activate();

			// listeners
			scope.$on( 'add:timer', function ( ev, evidence, start ) {
				pushToArray( evidence );

				if ( !start ) {
					startTimeHandler( evidence.id );
				}
			} );

			scope.$on( 'start:time:', function ( ev, id ) {
				startTimeHandler( id );
			} );

			scope.$on( 'stop:time:', function ( ev, id ) {
				stopTimeHandler( id );
			} );

			scope.$on( 'clear:time:', function ( ev, id, fromAdd ) {
				clearPopup( id, fromAdd );
			} );

			scope.$on( 'check:timer:', function ( ev, id ) {
				var evidence = _.find( scope.timerArr, { 'id' : id } );
				var start    = true;

				if ( evidence.interval === null ) {
					start = false;
				}

				scope.$root.$broadcast( evidence.changeBankLabel, start, evidence.description );
			} );

			scope.$on( 'change:label:', function ( ev, id, start ) {
				var evidence = _.find( scope.timerArr, { 'id' : id } );

				changeLabelHandler( evidence, start );
			} );

			scope.$on( 'delete:timer', function ( ev, id ) {
				stopTimeHandler( id );

				var evidence = _.find( scope.timerArr, { 'id' : id } );

				scope.timerArr.splice( scope.timerArr.indexOf( evidence ), 1 );
			} );

			scope.$on( 'check:active:timers', function ( ev, submit ) {
				checkActiveTimers( submit );
			} );

			// end for listeners

			scope.startTimeHandler = startTimeHandler;
			scope.stopTimeHandler  = stopTimeHandler;
			scope.clearPopup       = clearPopup;

			$window.addEventListener( 'focus', function () {
				addLostTime();
			} );

			$window.addEventListener( 'blur', function () {
				timeBefore = new Date();
			} );
		}

		var directive = {
			'link'     : link,
			'restrict' : 'A',
			'scope'    : {
				'model' : '='
			}
		};

		return directive;
	}

	angular
		.module( 'app.components' )
		.directive( 'timerDirective', timerDirective );
} )();
